import Vue from 'vue'
import Vuex from 'vuex'

import GalleryGuerraDeParrillas30e from '@/store/gallery-guerra-de-parrillas-30e'
import GalleryGuerraDeParrillas16e from '@/store/gallery-guerra-de-parrillas-16e'
import GalleryMariaRockola from '@/store/gallery-maria-rockola'
import GalleryCocinaSaludable from '@/store/gallery-cocina-saludable'
import GalleryGuerraDeParrillas from '@/store/gallery-guerra-de-parrillas'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    articles: [
      {
        title: 'Guerra de Parrillas',
        slug: 'guerra-de-parrillas-30e',
        beforetitle: '30 de Enero',
        undertitle: 'En esta tercera guerra de parrillas realizada en Casa Weber, los invitados tuvieron la oportunidad de conocer y probar los modelos Silverado, Colorado, Traverse y Tahoe.',
        img: 'content/chevrolet-guerra-30e.jpg',
        video: 'content/loop-chevrolet-guerra-30e-compressed.mp4',
        content: '<div class="wrap"><p>Chevrolet sorprendió a sus invitados, el pasado miércoles 30 de enero, con la tercera guerra de parrillas realizada en Casa Weber. Los invitados tuvieron la oportunidad de conocer y probar los modelos Silverado, Colorado, Traverse y Tahoe, en un entretenido Test Drive. A continuación disfrutaron de los conocimientos del argentino Bernardo Borgeat , y de Nicolás Carrasco, reconocido chef y productor gastronómico chileno. Los asistentes se dividieron en dos equipos, que compitieron por increíbles premios cocinando la mejor preparación de una entrada y plato de fondo.</p><VideoPlayer iframe="//rudo.video/vod/bGRgvF/autostart/false"></VideoPlayer></div>',
        // alignment: 'left top',
        share: {
          title: 'Tercera Guerra de Parrillas, presentada por Chevrolet',
          description: 'En esta tercera guerra de parrillas realizada en Casa Weber, los invitados tuvieron la oportunidad de conocer y probar los modelos Silverado, Colorado, Traverse y Tahoe.',
          img: 'content/chevrolet-guerra-30e.jpg',
        },
        credits: [
          // {
          //   title: 'Textos',
          //   author: 'Belén Peña L.'
          // }
        ],
        gallery: GalleryGuerraDeParrillas30e
      },
      {
        title: 'Guerra de Parrillas',
        slug: 'guerra-de-parrillas-16e',
        beforetitle: '16 de Enero',
        undertitle: 'El pasado miércoles 16 de enero en casa Weber, se realizó la segunda guerra de parrillas presentada por Chevrolet.',
        img: 'content/chevrolet-guerra-16e.jpg',
        video: 'content/loop-chevrolet-guerra-16e-compressed.mp4',
        content: '<div class="wrap"><p>El pasado miércoles 16 de enero en casa Weber, se realizó la segunda guerra de parrillas presentada por Chevrolet, con una competencia por equipos donde participaron por increíbles premios. Los asistentes aprendieron diferentes técnicas parrilleras. El evento estuvo a cargo del colombiano Michael Furmanski, y de Nicolás Carrasco, reconocido chef y productor gastronómico. Además, los socios de Club La Tercera vivieron la experiencia de un test drive de los modelos Silverado, Colorado y Traverse.</p><VideoPlayer iframe="//rudo.video/vod/bGRguX/autostart/false"></VideoPlayer></div>',
        // alignment: 'left top',
        share: {
          title: 'Segunda Guerra de Parrillas, presentada por Chevrolet',
          description: 'El pasado miércoles 16 de enero en casa Weber, se realizó la segunda guerra de parrillas presentada por Chevrolet.',
          img: 'content/chevrolet-guerra-16e.jpg',
        },
        credits: [
          // {
          //   title: 'Textos',
          //   author: 'Belén Peña L.'
          // }
        ],
        gallery: GalleryGuerraDeParrillas16e
      },
      {
        title: 'María Rockola',
        slug: 'maria-rockola',
        beforetitle: 'Presentada por Chevrolet',
        undertitle: 'El 13 de enero, Chevrolet presentó a la María Rockola en un entretenido evento, en el que los invitados participaron en un karaoke con la banda de la actriz María José Illanes, junto a un cóctel y bar abierto. Además, los asistentes realizaron un test drive con los modelos más exclusivos de Chevrolet.',
        img: 'content/maria-rockola.jpg',
        video: 'content/loop-chevrolet-maria-compressed.mp4',
        content: '<div class="wrap"><p>El 9 de enero, Chevrolet presentó a la María Rockola en un entretenido evento, en el que los invitados participaron en un karaoke con la banda de la actriz María José Illanes, junto a un cóctel y bar abierto. Además, los asistentes realizaron un test drive con los modelos más exclusivos de Chevrolet.</p><VideoPlayer iframe="//rudo.video/vod/bG8X54/autostart/false"></VideoPlayer></div>',
        // alignment: 'left top',
        share: {
          title: 'La María Rockola, presentada por Chevrolet',
          description: 'El 9 de enero, Chevrolet presentó a la María Rockola en un entretenido evento, en el que los invitados participaron en un karaoke con la banda de la actriz María José Illanes, junto a un cóctel y bar abierto. Además, los asistentes realizaron un test drive con los modelos más exclusivos de Chevrolet.',
          img: 'content/maria-rockola.jpg',
        },
        credits: [
          // {
          //   title: 'Textos',
          //   author: 'Belén Peña L.'
          // }
        ],
        gallery: GalleryMariaRockola
      },
      {
        title: 'Guerra de Parrillas',
        slug: 'guerra-de-parrillas',
        beforetitle: 'Presentada por Chevrolet',
        undertitle: 'El pasado miércoles 17 de octubre en casa Weber, se realizó una guerra de parrillas con una competencia por equipos donde participaron por increíbles premios.',
        img: 'content/loop-chevrolet-guerra-de-parrillas-compressed.jpg',
        video: 'content/loop-chevrolet-guerra-de-parrillas-compressed.mp4',
        content: '<div class="wrap"><p>El pasado miércoles 17 de octubre en casa Weber, se realizó una guerra de parrillas con una competencia por equipos donde participaron por increíbles premios. Los asistentes aprendieron diferentes técnicas parrilleras, para todo tipo de gustos. El evento estuvo a cargo de Bernardo Borgeat, experto en asados y de Nicolás Carrasco, reconocido chef y productor gastronómico. Además, los socios de Club La Tercera vivieron la experiencia de un test drive de los modelos Silverado, Colorado y Traverse.</p><VideoPlayer iframe="//rudo.video/vod/bG7e1g/autostart/false"></VideoPlayer></div>',
        // alignment: 'left top',
        share: {
          title: 'Guerra de parrillas, presentada por Chevrolet',
          description: 'El pasado miércoles 17 de octubre en casa Weber, se realizó una guerra de parrillas con una competencia por equipos donde participaron por increíbles premios.',
          img: 'content/loop-chevrolet-guerra-de-parrillas-compressed.jpg',
        },
        credits: [
          // {
          //   title: 'Textos',
          //   author: 'Belén Peña L.'
          // }
        ],
        gallery: GalleryGuerraDeParrillas
      },
      {
        title: 'Taller de Cocina saludable',
        beforetitle: 'Presentado por Chevrolet',
        slug: 'taller-de-cocina-saludable',
        undertitle: 'El jueves 25 de octubre en Casa La Tercera, se realizó un entretenido taller de cocina saludable a cargo de Connie Achurra.',
        img: 'content/loop-chevrolet-comida-saludable-compressed.jpg',
        video: 'content/loop-chevrolet-comida-saludable-compressed.mp4',
        content: '<div class="wrap"><p>El jueves 25 de octubre en Casa La Tercera, se realizó un entretenido taller de cocina saludable a cargo de Connie Achurra, destacada cocinera y autora del libro “Cocina sana y feliz”. Las socias de Club La Tercera aprendieron deliciosas preparaciones de platos de entrada, fondo y postres, todo cocinado con ingredientes sanos y nutritivos. Además de un test drive de los modelos Trail Blazer, Traverse y Equinox.</p><VideoPlayer iframe="//rudo.video/vod/bG7e05/autostart/false"></VideoPlayer></div>',
        share: {
          title: 'El jueves 25 de octubre en Casa La Tercera, se realizó un entretenido taller de cocina saludable a cargo de Connie Achurra.',
          description: '',
          img: 'content/loop-chevrolet-comida-saludable-compressed.jpg',
        },
        credits: [

        ],
        gallery: GalleryCocinaSaludable
      }
    ],
    config: {
      logo: 'assets/images/logos/latercera.svg',
      title: 'Chevrolet',
      url: 'https://www.latercera.com/canal/tendencias',
      papeldigital: true,
      baseurl: 'https://especiales.latercera.com/experiencia-chevrolet',
      description: 'Experiencia Chevrolet',
      hashtag: '#experienciachevrolet',
      brandtitle: 'Presentado por Chevrolet',
      reporttitle: 'Especiales La Tercera',
      jumbo: {
        img: 'content/loop-chevrolet-main-compressed.jpg',
        video: 'content/loop-chevrolet-main-compressed.mp4',
        under: '',
      },
      img: 'content/share.jpg',
      slug: '/',
      gallery: false,
      lab: {
        logo: 'assets/images/logos-white/laboratorio-de-contenidos-de-marca.svg',
        title: 'Laboratorio de Contenidos',
        url: {
          name: "home"
        },
        height: '30'
      },
      brand: {
        logo: 'assets/images/logos-white/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '20'
      },
      sponsor: {
        logo: 'assets/images/logo-chevrolet.png',
        title: 'Chevrolet',
        url: {
          name: "home"
        },
        height: '45'
      },
      special: {
        logo: 'assets/images/logo-experiencia-chevrolet-white.svg',
        title: 'Experiencia Chevrolet',
        url: {
          name: "home"
        },
        height: '40'
      },
      front: {
        logo: 'assets/images/logo-experiencia-chevrolet-white.svg',
        title: 'Experiencia Chevrolet',
        url: {
          name: "home"
        },
        height: '200'
      },
      site: {
        logo: 'assets/images/logos/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '37'
      },
      menu: {
        logo: 'assets/images/logos/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '13'
      },
      'papeldata': {
        url: 'https://edition.pagesuite.com/html5/reader/production/default.aspx?pubname=&pubid=33084897-397a-48cc-b3c0-3ce1ec447137',
        image: 'https://edition.pagesuite-professional.co.uk/get_image.aspx?w=300&pbid=33084897-397a-48cc-b3c0-3ce1ec447137&pnum=01&nocache=0609201815'
      },
      'navigation': [
        {
          url: 'https://www.latercera.com/',
          name: 'Inicio'
        },
        {
          url: 'https://www.latercera.com/la-tercera-pm/',
          name: 'La Tercera PM'
        },
        {
          url: 'https: //www.latercera.com/canal/pulso/',
          name: 'Pulso'
        },
        {
          url: 'https://www.latercera.com/canal/politica/',
          name: 'Política'
        },
        {
          url: 'https://www.latercera.com/canal/nacional/',
          name: 'Nacional'
        },
        {
          url: 'https://www.latercera.com/canal/mundo/',
          name: 'Mundo'
        },
        {
          url: 'https://www.latercera.com/canal/opinion/',
          name: 'Opinión'
        },
        {
          url: 'https://www.latercera.com/canal/tendencias/',
          name: 'Tendencias'
        },
        {
          url: 'https://www.latercera.com/canal/cultura/',
          name: 'Cultura'
        },
        {
          url: 'https://www.latercera.com/canal/cultura/',
          name: 'Entretención'
        },
        {
          url: 'https://www.latercera.com/canal/reportajes/',
          name: 'Reportajes'
        },
        {
          url: 'https://www.latercera.com/canal/el-deportivo/',
          name: 'El Deportivo'
        },
        {
          url: 'https://www.latercera.com/canal/la-tercera-tv/',
          name: 'La Tercera TV'
        },
        {
          url: 'http://edition.pagesuite.com/html5/reader/production/default.aspx?pubname=&pubid=33084897-397a-48cc-b3c0-3ce1ec447137',
          name: 'Edición Impresa'
        }
      ],
      'socialnetworks': [
        {
          url: 'https://twitter.com/latercera',
          icon: 'twitter', //TODO, cargar svgs dinámicamente en init
          name: 'Twitter'
        },
        {
          url: 'https://www.facebook.com/laterceracom',
          icon: 'facebook-f', //TODO, cargar svgs dinámicamente en init
          name: 'Facebook'
        },
        {
          url: 'https://flipboard.com/@latercera',
          icon: 'flipboard', //TODO, cargar svgs dinámicamente en init
          name: 'Flipboard'
        },
        {
          url: 'https://www.instagram.com/laterceracom/',
          icon: 'instagram', //TODO, cargar svgs dinámicamente en init
          name: 'Instagram'
        },
        {
          url: 'https://www.youtube.com/user/latercera',
          icon: 'youtube', //TODO, cargar svgs dinámicamente en init
          name: 'Youtube'
        }
      ]
    }
  },
  mutations: {
    SET_LOGO: (state, val) => {
      state.config.logo = val
    },
    TOGGLE_GALLERY: (state) => {
      state.config.gallery = !state.config.gallery
    },
  },
  actions: {
    setLogo(context, val) {
      context.commit('SET_LOGO', val)
    },
    toggleGallery(context) {
      context.commit('TOGGLE_GALLERY')
    },
  },
  getters: {
    getArticle: (state) => (slug) => {
      const articlearr = state.articles.filter(i => i.slug === slug)
      return articlearr[0]
    },
    getArticleIndex: (state) => (slug) => {
      const articleIndex = state.articles.findIndex(i => i.slug === slug)
      return articleIndex
    },
    getGallery: (state) => (slug) => {
      const galleryarr = state.articles.filter(i => i.slug === slug)
      console.log(galleryarr[0].gallery.basepath)
      return galleryarr[0].gallery
    },
  }
})
